<template>
  <div>
    <!-- <div class="row justify-content-between align-items-center">
      <div class="col-md-6 customHeading">
        <h3>{{ moduleName }}</h3>
      </div>
      <div class="col-md-3">
        <b-form-group
          label=""
          label-for="datepicker-2"
          autocomplete="off"
          style="margin-bottom: 0px;"
        >
          <b-form-datepicker
            id="datepicker-2"
            v-model="FromDate"
            @input="getGraphData()"
            placeholder="Choose Start Date"
            :date-format-options="{
              year: 'numeric',
              month: 'long',
              day: '2-digit',
            }"
            local="en"
          >
          </b-form-datepicker>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
          label=""
          style="margin-bottom: 0px;"
          label-for="datepicker-1"
          autocomplete="off"
        >
          <b-form-datepicker
            id="datepicker-1"
            v-model="ToDate"
            placeholder="Choose End Date"
            @input="getGraphData()"
            :date-format-options="{
              year: 'numeric',
              month: 'long',
              day: '2-digit',
            }"
            local="en"
          >
          </b-form-datepicker>
        </b-form-group>
      </div>
    </div> -->

    <!-- <div class="">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="Year"
                  label-for="datepicker-2"
                  autocomplete="off"
                >
                  <datepicker
                    :language="en"
                    :minimumView="'year'"
                    :maximumView="'year'"
                    :initialView="'year'"
                    :format="'yyyy'"
                    v-model="Year"
                    placeholder="Select Year"
                  ></datepicker>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="Month"
                  label-for="datepicker-2"
                  autocomplete="off"
                >
                  <datepicker
                    :language="en"
                    :minimumView="'month'"
                    :maximumView="'month'"
                    :initialView="'month'"
                    :format="'MMMM yyyy'"
                    v-model="Month"
                    placeholder="Select Month"
                  ></datepicker>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="Start Date"
                  label-for="datepicker-2"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-2"
                    v-model="FromDate"
                    @input="getGraphData()"
                    placeholder="Choose Start Date"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'long',
                      day: '2-digit',
                    }"
                    local="en"
                    size="sm"
                    :max="EndDate"
                  >
                  </b-form-datepicker>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="End Date"
                  label-for="datepicker-1"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-1"
                    v-model="ToDate"
                    placeholder="Choose End Date"
                    @input="getGraphData()"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'long',
                      day: '2-digit',
                    }"
                    local="en"
                    size="sm"
                    :min="FromDate"
                  >
                  </b-form-datepicker>
                </b-form-group>
              </div>

              <div class="custom-btn">
                <b-form-group
                  label="Start Time"
                  label-for="Start Time"
                  autocomplete="off"
                >
                  <b-form-select
                    v-model="SelectedStartTimeSlot"
                    :options="timeSlots"
                    value-field="id"
                    text-field="timeSlot"
                    required
                    size="sm"
                    @change="getTimeWiseProductions"
                  >
                    <b-form-select-option :value="null" disabled hidden
                      >Select Start Time</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="End Time"
                  label-for="End Time"
                  autocomplete="off"
                >
                  <b-form-select
                    v-model="SelectedEndTimeSlot"
                    :options="timeSlots"
                    value-field="id"
                    text-field="timeSlot"
                    required
                    size="sm"
                    @change="GetEndTimeWiseProductions"
                  >
                    <b-form-select-option :value="null" disabled hidden
                      >Select End Time</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <!-- <div class="col-md-2 customHeading">
            <h3>{{ moduleName }}</h3>
          </div> -->
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <!-- <div class="custom-btn">
                <a title="Clear Filters" @click="clearFilter">
                  <div class="custom-icon icon">
                    <b-icon icon="plus" scale="1.7"></b-icon>
                  </div>
                </a>
              </div> -->

              <!-- Separator -->
              <!-- <div class="custom-btn">
                <div class="custom-icon icon">
                  <span style="font-weight: 300; font-size: 15px">|</span>
                </div>
              </div> -->

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <a
                  href="#filterSection"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="filterSection"
                >
                  <div class="icon">
                    <b-icon icon="filter" scale="1.7"></b-icon>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="collapse" id="filterSection">
        <div class="card card-body custom-filter-body">
          <div class="custom-filter-wrap">
            <div
              class="container-fluid custom-row d-flex justify-content-between"
            >
              <div class="custom-filter-column">
                <b-form>
                  <!---CHOOSE START DATE-->
                  <b-form-group
                    label=""
                    label-for="datepicker-2"
                    autocomplete="off"
                  >
                    <datepicker
                      :language="en"
                      :minimumView="'year'"
                      :maximumView="'year'"
                      :initialView="'year'"
                      :format="'yyyy'"
                      v-model="Year"
                      placeholder="Select Year"
                      @input="yearClicked()"
                    ></datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form>
                  <!---CHOOSE END DATE-->
                  <b-form-group
                    label=""
                    label-for="datepicker-2"
                    autocomplete="off"
                  >
                    <datepicker
                      :language="en"
                      :minimumView="'month'"
                      :maximumView="'month'"
                      :initialView="'month'"
                      :format="'MMMM yyyy'"
                      v-model="Month"
                      placeholder="Select Month"
                      @input="monthClicked()"
                    ></datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form>
                  <b-form-group
                    label=""
                    label-for="datepicker-2"
                    autocomplete="off"
                  >
                    <b-form-datepicker
                      id="datepicker-2"
                      v-model="FromDate"
                      @input="fromDateClicked"
                      placeholder="Choose Start Date"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'long',
                        day: '2-digit',
                      }"
                      local="en"
                      :max="ToDate"
                    >
                    </b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form>
                  <!---CHOOSE WHEAT RECEIVED FROM-->
                  <b-form-group
                    label=""
                    label-for="datepicker-1"
                    autocomplete="off"
                  >
                    <b-form-datepicker
                      id="datepicker-1"
                      v-model="ToDate"
                      placeholder="Choose End Date"
                      @input="toDateClicked()"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'long',
                        day: '2-digit',
                      }"
                      local="en"
                      :min="FromDate"
                    >
                    </b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form>
                  <!---CHOOSE TYPE-->
                  <b-form-group
                    label=""
                    label-for="Start Time"
                    autocomplete="off"
                  >
                    <b-form-select
                      v-model="SelectedStartTimeSlot"
                      :options="timeSlots"
                      value-field="id"
                      text-field="timeSlot"
                      required
                      @change="getTimeWiseProductions"
                    >
                      <b-form-select-option :value="null" disabled hidden
                        >Select Start Time</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                  <!---CHOOSE WHEAT TYPE-->
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form>
                  <b-form-group
                    label=""
                    label-for="End Time"
                    autocomplete="off"
                  >
                    <b-form-select
                      v-model="SelectedEndTimeSlot"
                      :options="timeSlots"
                      value-field="id"
                      text-field="timeSlot"
                      required
                      @change="GetEndTimeWiseProductions"
                    >
                      <b-form-select-option :value="null" disabled hidden
                        >Select End Time</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <div class="custom-icon icon cancel-icon" title="Clear Filters">
                  <b-icon
                    icon="x"
                    scale="1.6"
                    variant="danger"
                    @click="clearFilter"
                  ></b-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-accordion-separator">
      <div class="custom-separator"></div>
    </div>

    <!-- <div class="row">
      <div class="col">
        <hr
          color="#CACACA"
          style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;"
        />
      </div>
    </div> -->

    <div style="width:70%;margin:auto;margin-top:5%;">
      <BarGraph
        v-if="graphData != null"
        :chartData="graphData"
        :options="graphOptions"
      ></BarGraph>
    </div>
    <Spinner
      v-if="isLoading"
      message="Loading..."
      size="medium"
      line-fg-color="rgb(222 224 219"
      line-bg-color="rgb(68 66 62)"
    >
    </Spinner>
    <div v-if="graphData == null && !isLoading" style="text-align:center">
      <b style="color:red">No data found</b>
    </div>

    <Toaster ref="toaster" />
  </div>
</template>
<script>
// import VueCharts from 'vue-chartjs'
import BarGraph from "./bar-graph";
import axios from "axios";
import Toaster from "../toaster";
import Spinner from "vue-simple-spinner";
import Datepicker from "vuejs-datepicker";
import { en } from "vuejs-datepicker/dist/locale";
import moment from "moment";

export default {
  name: "ProductionWheatSacksGraph",
  components: {
    BarGraph,
    Spinner,
    Toaster,
    Datepicker,
  },
  data() {
    return {
      moduleName: "Production Wheat Grinding Graphical Report",
      en: en,
      graphData: null,
      graphOptions: Object,
      FromDate: new Date(),
      ToDate: new Date(),
      isLoading: true,
      timeSlots: null,
      SelectedStartTimeSlot: null,
      SelectedEndTimeSlot: null,
      apiStatus: 10, // defaultValue
      Year: null,
      Month: null,
      StartTimeId: null,
      EndTimeId: null,
    };
  },
  mounted() {
    // this.FromDate = new Date(
    //   this.FromDate.getFullYear(),
    //   this.FromDate.getMonth(),
    //   this.FromDate.getDay() - 7,
    //   this.FromDate.getHours()
    // );
    this.FromDate = new Date();
    this.FromDate.setDate(this.FromDate.getDate() - 6);
    // this.ToDate = new Date(
    //   this.ToDate.getFullYear(),
    //   this.ToDate.getDay() + 7,
    //   0,
    //   this.ToDate.getHours()
    // );
    this.ToDate = new Date(); //get current date
    this.graphOptions = {
      responsive: true,
      maintainAspectRatio: false,
      title: { display: true, text: "Wheat Sacks Bar Chart"},
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: function(label) {
                return label.toLocaleString() + " Sacks";
              },
            },
          },
        ],
        xAxes: [{}],
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function(tooltipItem) {
            return (
              "Total No. of Wheat Sacks: " + tooltipItem.yLabel.toLocaleString()
            );
          },
        },
      },
    };
    this.getGraphData();
    this.gettimeSlots();
  },
  methods: {
    getGraphData() {
      this.isLoading = true;
      this.graphData = null;

      let model = {
        CompanyId: this.$auth.user().companyId,
        Year: this.Year,
        Month: this.Month,
        FromDate: this.FromDate,
        ToDate: this.ToDate,
        StartTimeId: this.SelectedStartTimeSlot,
        EndTimeId: this.SelectedEndTimeSlot,
      };

      if (this.Year != null) {
        model.Year = this.Year.getFullYear(); //send only int year value
      }

      if (this.Month != null) {
        model.Month = this.Month.getMonth() + 1; //return month in int
        model.Year = this.Month.getFullYear();
        console.log("Month and year is", model.Month, model.Year);
      }

      this.FromDate = moment(String(this.FromDate)).format("YYYY-MM-DD");
      this.ToDate = moment(String(this.ToDate)).format("YYYY-MM-DD");
      console.log(this.FromDate, this.ToDate);

      axios
        .post("/productionreport/GetProductionWheatSacksData", model)
        .then((res) => {
          //   console.log(res)
          this.isLoading = false;
          if (res.data.status == 1) {
            this.graphData = res.data.data;
            this.data = res.data;
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
          } else {
            this.graphData = null;
          }
        });
    },

    gettimeSlots() {
      axios
        .post("/timeslots/getall", { CompanyId: this.$auth.user().companyId })
        .then((res) => {
          //  console.log(res.data)
          if (res.data.status == 1) {
            this.timeSlots = res.data.data;
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
          }
        })
        .catch((err) => {
          console.warn("error during http call", err);
        });
    },

    yearClicked() {
      this.Month = null;
      this.getGraphData();
    },

    monthClicked() {
      this.Year = null;
      this.getGraphData();
    },

    fromDateClicked() {
      // by default one week gap should be selected
      this.Year = null;
      this.Month = null;
      // if (
      //   this.SelectedStartTimeSlot === null &&
      //   this.SelectedEndTimeSlot === null
      // ) {
      //   var formatedDate = moment(String(this.FromDate)).format("YYYY/MM/DD");
      //   let date = new Date(formatedDate);
      //   console.log("Date is", date);
      //   this.ToDate = new Date();
      //   this.ToDate.setDate(date.getDate() + 6);

      //   // console.log("From date is ",this.FromDate);
      //   console.log("To date is ", this.ToDate);
      // }

      this.getGraphData();

      // this.getGraphData();
    },

    toDateClicked() {
      this.Year = null;
      this.Month = null; //clear month

      this.getGraphData();
    },

    getTimeWiseProductions() {
      this.Year = null;
      this.Month = null; //clear month

      this.graphData = null;
      

      console.log("Called from 1");
      this.SelectedEndTimeSlot = 24; //select last timeslot

      this.getGraphData();
     
    },

    GetEndTimeWiseProductions() {
      this.Year = null;
      this.Month = null; //clear month

     

      console.log("Called from 2");
      //IF END TIME IS LESS THEN START TIME GIVE AN ERROR MSG
      if (
        this.SelectedEndTimeSlot < this.SelectedStartTimeSlot &&
        this.FromDate === this.ToDate
      ) {
        // this.$refs.toaster.showToast("Error", "danger", "Please select correct end time");
        this.$bvToast.toast("Please select correct End Time", {
          title: "Error",
          solid: true,
          variant: "danger",
        });
        return;
      }
      
      this.productionData = null;
      this.getGraphData();
    },

    clearFilter() {
      this.Year = null;
      this.Month = null;
      this.SelectedStartTimeSlot = null;
      this.SelectedEndTimeSlot = null;
    },
  },
};
</script>

<style scoped>
/* button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
select#class-dropdown {
  width: 80%;
  margin-left: 16%;
} */
.custom-row {
  overflow: visible !important;
}
.form-group {
  margin-bottom: 0.4rem;
}
.nav-tabs {
  font-size: 22px !important;
  border-bottom: none !important;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border-bottom: 2px solid transparent !important;
}
.custom-accordion-separator > .custom-separator {
  margin: 1px 0 15px 0 !important;
}
.vdp-datepicker > div > input {
  border: 1px solid #ccc !important;
}
input {
  border: 0px solid !important;
}
</style>

<!-- <style lang="stylus">
@import '../../assets/css/style1.styl';
</style> -->
